
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SeksiPenyakitForm extends Vue {
  @Prop() value!: any;
  @Prop() label!: string;

  localData: any = this.getDefault();

  getDefault() {
    return {
      tahu_penyakit: null,
      sumber_info: [],
      sumber_info_lainnya: null,
      info_jangka_waktu: null,
      jangka_waktu_satuan: null,
      pemeriksaan_rutin: null,
      pemeriksaan_rutin_tempat: null,
      penyakit_penyerta: null
    };
  }

  created() {
    if (this.value) {
      this.localData = { ...this.getDefault(), ...this.value };
      if (!Array.isArray(this.localData.sumber_info)) {
        this.localData.sumber_info = [];
      }
    }
  }

  // Re-seeding localData from a deep value-watch creates a feedback loop with
  // the localData emit below (emit → parent updates value → watch re-seeds →
  // emit again), which Vue aborts as an infinite update and leaves checkboxes
  // visually unresponsive. The parent remounts this component when switching
  // to/from edit mode, so created() is enough to seed from incoming value.
  @Watch("localData", { deep: true })
  onLocalChange() {
    this.$emit("input", { ...this.localData });
  }
}
